<script context="module">
  export const ICONS = {
    // Static icons
    "logo-default": LogoDefaultSVG,

    // Customizable icons (Svelte components)
    plus: PlusSVG,
    shield: ShieldSVG,
    chart: ChartSVG,
    menu: MenuSVG,
    x: XSVG,
    "social-x": SocialXSVG,
    "social-facebook": SocialFacebookSVG,
    "social-telegram": SocialTelegramSVG,
    "social-linkedin": SocialLinkedInSVG,
    "social-instagram": SocialInstagramSVG,
    "social-mail": SocialMailSVG,
    "arrow-right": ArrowRightSVG,
    "chevron-up": ChevronUpSVG,
  };
</script>

<script>
  import LogoDefaultSVG from "lib/components/svg/LogoDefault.svelte";
  import PlusSVG from "lib/components/svg/Plus.svelte";
  import ShieldSVG from "lib/components/svg/Shield.svelte";
  import ChartSVG from "lib/components/svg/Chart.svelte";
  import MenuSVG from "lib/components/svg/Menu.svelte";
  import XSVG from "lib/components/svg/X.svelte";
  import ArrowRightSVG from "lib/components/svg/ArrowRight.svelte";
  import SocialXSVG from "lib/components/svg/SocialX.svelte";
  import SocialFacebookSVG from "lib/components/svg/SocialFacebook.svelte";
  import SocialTelegramSVG from "lib/components/svg/SocialTelegram.svelte";
  import SocialLinkedInSVG from "lib/components/svg/SocialLinkedIn.svelte";
  import SocialInstagramSVG from "lib/components/svg/SocialInstagram.svelte";
  import SocialMailSVG from "lib/components/svg/SocialMail.svelte";
  import ChevronUpSVG from "lib/components/svg/ChevronUp.svelte";

  // Props
  export let name;
  export let width = undefined;
  export let height = undefined;
  export let color = undefined;
  export let colorName = undefined;
  export let ref = undefined;

  let IconComponent;
  // Reactively replace icon if name changes for the same component instance
  $: IconComponent = ICONS[name];
</script>

<svelte:component
  this={IconComponent}
  {width}
  {height}
  {ref}
  color={!!colorName ? `var(--color-${colorName})` : color}
/>
